import { render, staticRenderFns } from "./MyTipster.vue?vue&type=template&id=6463d57c&"
import script from "./MyTipster.vue?vue&type=script&lang=js&"
export * from "./MyTipster.vue?vue&type=script&lang=js&"
import style0 from "./MyTipster.vue?vue&type=style&index=0&id=6463d57c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports